module.exports = __webpack_public_path__ + "static/img/tool_05.93c63fe8.jpg";